// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tnXF","importantInfo":"styles_importantInfo__3xfeB"};